/* Q&A search popup: live suggestions under .fp-search inputs that carry
   data-node-url. A click (or Enter) navigates to the question's viewing
   page. The index comes from window.qaPageIndex (page-provided JSON:
   {question, search_text, node, crumb}) and the UI strings from
   window.qaPageI18n. Ranking mirrors the portal search: normalized
   (umlaut + hyphen folding), AND over tokens, question beats
   content, word-prefix beats substring. Each suggestion carries the
   question's book / chapter as a breadcrumb line. */
(function () {
	function norm(s) {
		return (s || "").toLowerCase()
			.replace(/ä/g, "ae").replace(/ö/g, "oe").replace(/ü/g, "ue").replace(/ß/g, "ss")
			.replace(/[-\u2010-\u2015_]/g, "")
			.replace(/[^a-z0-9\s]/g, " ")
			.replace(/\s+/g, " ")
			.trim();
	}
	function escapeRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); }

	function init() {
		var wrap = document.querySelector(".fp-search");
		if (!wrap) return;
		var input = wrap.querySelector("input");
		if (!input) return;
		var nodeUrl = input.getAttribute("data-node-url");
		if (!nodeUrl) return; /* page wants inline filtering instead */
		var index = (window.qaPageIndex || []).map(function (item) {
			return { q: item.question, t: item.search_text, node: item.node, crumb: item.crumb || "" };
		});
		var i18n = window.qaPageI18n || {};
		if (!index.length) return;

		var popup = document.createElement("div");
		popup.className = "fp-search-popup";
		wrap.appendChild(popup);

		var results = [];
		var active = -1;

		function close() {
			popup.style.display = "none";
			active = -1;
		}
		function openResult(i) {
			if (i < 0 || i >= results.length) return;
			window.location.href = nodeUrl + encodeURIComponent(results[i].it.node);
		}

		function render() {
			var raw = input.value.trim();
			var q = norm(raw);
			var tokens = q ? q.split(" ") : [];
			if (!tokens.length) { close(); return; }

			results = [];
			index.forEach(function (it) {
				var qn = norm(it.q);
				var tn = norm(it.t);
				var matched = tokens.every(function (t) {
					return qn.indexOf(t) !== -1 || tn.indexOf(t) !== -1;
				});
				if (!matched) return;
				var score = 0;
				tokens.forEach(function (t) {
					var re = new RegExp("\\b" + escapeRe(t), "i");
					if (re.test(qn)) score += 50;
					else if (qn.indexOf(t) !== -1) score += 30;
					if (re.test(tn)) score += 12;
					else if (tn.indexOf(t) !== -1) score += 6;
				});
				if (qn.indexOf(q) !== -1) score += 40;
				results.push({ it: it, score: score });
			});
			results.sort(function (a, b) { return b.score - a.score; });
			results = results.slice(0, 8);

			popup.textContent = "";
			if (!results.length) {
				var empty = document.createElement("div");
				empty.className = "fp-search-popup-empty";
				empty.textContent = i18n.no_results || "No matching questions found.";
				popup.appendChild(empty);
			} else {
				results.forEach(function (r) {
					var a = document.createElement("a");
					a.className = "fp-search-popup-item";
					a.href = nodeUrl + encodeURIComponent(r.it.node);
					/* book / chapter breadcrumb above the question text */
					if (r.it.crumb) {
						var crumb = document.createElement("div");
						crumb.className = "fp-search-popup-crumb";
						crumb.textContent = r.it.crumb;
						a.appendChild(crumb);
					}
					var text = document.createElement("span");
					text.className = "fp-search-popup-q";
					text.textContent = r.it.q;
					a.appendChild(text);
					/* mousedown fires before the input's blur -> keep popup */
					a.addEventListener("mousedown", function (e) {
						e.preventDefault();
						window.location.href = a.href;
					});
					popup.appendChild(a);
				});
			}
			/* no pre-marked entry: only hover marks (CSS); Enter opens the top
			   result unless the user moved the selection with arrow keys */
			active = results.length ? 0 : -1;
			popup.style.display = "block";
		}

		var debounce = null;
		var clearBtn = wrap.querySelector(".fp-search-clear");
		function setClearVisible() {
			if (clearBtn) clearBtn.style.display = input.value.trim() ? "flex" : "none";
		}
		input.addEventListener("input", function () {
			clearTimeout(debounce);
			setClearVisible();
			debounce = setTimeout(render, 150);
		});
		input.addEventListener("focus", function () {
			if (input.value.trim()) render();
		});
		if (clearBtn) {
			clearBtn.addEventListener("click", function () {
				input.value = "";
				clearTimeout(debounce);
				close();
				setClearVisible();
				input.focus();
			});
		}
		input.addEventListener("keydown", function (e) {
			if (popup.style.display !== "block") return;
			if (e.key === "ArrowDown") {
				e.preventDefault();
				active = Math.min(active + 1, results.length - 1);
			} else if (e.key === "ArrowUp") {
				e.preventDefault();
				active = Math.max(active - 1, 0);
			} else if (e.key === "Enter") {
				e.preventDefault();
				openResult(active);
			} else if (e.key === "Escape") {
				close();
			}
		});
		document.addEventListener("click", function (e) {
			if (!wrap.contains(e.target)) close();
		});
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();